import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
type HeartConfig = {
  className: string;
  color: string;
  delay: number;
  duration: number;
  filled?: boolean;
  drift: number;
  tilt: number;
};
const hearts: HeartConfig[] = [{
  className: 'left-[1%] top-[5%] size-[clamp(42px,4.6vw,84px)]',
  color: 'text-[#D62B22]',
  delay: 0,
  duration: 5.8,
  drift: 18,
  tilt: 10,
  filled: true
}, {
  className: 'left-[10%] top-[27%] size-[clamp(30px,3.3vw,62px)]',
  color: 'text-[#E65B4E]',
  delay: 0.5,
  duration: 4.9,
  drift: -15,
  tilt: -12
}, {
  className: 'left-[3%] bottom-[5%] size-[clamp(38px,4.1vw,76px)]',
  color: 'text-[#C91F37]',
  delay: 1.1,
  duration: 6.3,
  drift: 14,
  tilt: 14,
  filled: true
}, {
  className: 'left-[20%] bottom-[11%] size-[clamp(27px,3vw,56px)]',
  color: 'text-[#E88472]',
  delay: 1.7,
  duration: 5.4,
  drift: -12,
  tilt: -10
}, {
  className: 'left-[29%] top-[2%] size-[clamp(24px,2.7vw,50px)]',
  color: 'text-[#D62B22]',
  delay: 0.9,
  duration: 4.7,
  drift: 10,
  tilt: 9
}, {
  className: 'left-[34%] bottom-[3%] size-[clamp(20px,2.4vw,44px)]',
  color: 'text-[#C94A37]',
  delay: 2.2,
  duration: 5.9,
  drift: -9,
  tilt: -8,
  filled: true
}, {
  className: 'right-[1%] top-[6%] size-[clamp(44px,4.8vw,88px)]',
  color: 'text-[#D62B22]',
  delay: 0.2,
  duration: 6.1,
  drift: -18,
  tilt: -12,
  filled: true
}, {
  className: 'right-[11%] top-[29%] size-[clamp(31px,3.5vw,64px)]',
  color: 'text-[#E65B4E]',
  delay: 0.7,
  duration: 5.2,
  drift: 15,
  tilt: 13
}, {
  className: 'right-[3%] bottom-[4%] size-[clamp(39px,4.3vw,80px)]',
  color: 'text-[#C91F37]',
  delay: 1.3,
  duration: 6.5,
  drift: -14,
  tilt: -15,
  filled: true
}, {
  className: 'right-[21%] bottom-[10%] size-[clamp(28px,3.1vw,58px)]',
  color: 'text-[#E88472]',
  delay: 1.9,
  duration: 5.6,
  drift: 12,
  tilt: 11
}, {
  className: 'right-[29%] top-[1%] size-[clamp(25px,2.8vw,52px)]',
  color: 'text-[#D62B22]',
  delay: 1,
  duration: 4.8,
  drift: -10,
  tilt: -9
}, {
  className: 'right-[35%] bottom-[2%] size-[clamp(21px,2.5vw,46px)]',
  color: 'text-[#C94A37]',
  delay: 2.4,
  duration: 6,
  drift: 9,
  tilt: 8,
  filled: true
}];
export function FloatingHearts() {
  const reduceMotion = useReducedMotion();
  return <div className="pointer-events-none absolute inset-0 z-[1]" aria-hidden="true" data-id="element-183" data-mp="2eus6d9e92ek1">
      {hearts.map((heart, index) => <motion.div key={index} className={`absolute ${heart.color} ${heart.className}`} initial={{
      opacity: heart.filled ? 0.88 : 0.72,
      scale: 1,
      rotate: heart.tilt
    }} animate={reduceMotion ? {
      opacity: heart.filled ? 0.88 : 0.72,
      rotate: heart.tilt
    } : {
      y: [18, -20, -62, 18],
      x: [0, heart.drift, -heart.drift, 0],
      rotate: [heart.tilt, -heart.tilt, heart.tilt * 0.7, heart.tilt],
      scale: [1, 1.16, 0.94, 1],
      opacity: heart.filled ? 0.88 : 0.72
    }} transition={reduceMotion ? {
      duration: 0
    } : {
      duration: Math.max(3.6, heart.duration - 1.2),
      delay: heart.delay * 0.25,
      repeat: Infinity,
      ease: 'easeInOut',
      times: [0, 0.3, 0.7, 1]
    }} data-id="element-184" data-mp="29x9tx910xh7a" data-mpi={index}>
          <HeartIcon className="h-full w-full" fill={heart.filled ? 'currentColor' : 'none'} strokeWidth={heart.filled ? 1.5 : 1.8} data-id="element-185" data-mp="bfznod7nzkbj" />
        </motion.div>)}
    </div>;
}